import { render, staticRenderFns } from "./productcontent.vue?vue&type=template&id=57bf9a8f&"
import script from "./productcontent.vue?vue&type=script&lang=js&"
export * from "./productcontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports